<ng-template #template>
  <ng-container *ngIf="!!componentName">
    <ng-template [component]="{ name: componentName, data: componentData }"></ng-template>
  </ng-container>
  <ng-container *ngIf="!componentName && contentTempl">
    <ng-container *ngTemplateOutlet="contentTempl"></ng-container>
  </ng-container>
</ng-template>